<template>
  <section class="py-16 bg-backgroundLight">
    <div class="container mx-auto px-6">
      <div class="mb-8 text-center md:text-left">
        <p class="text-xs uppercase tracking-[0.22em] text-gold font-semibold">Communauté</p>
        <h2 class="mt-2 text-3xl md:text-4xl font-bold text-primary">Salons de ta zone</h2>
        <p class="mt-3 text-secondary max-w-2xl">
          Échangez avec les autres profils de votre territoire, discutez des performances, des idées et des opportunités locales.
        </p>
      </div>

      <div class="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        <router-link
          v-for="room in rooms"
          :key="room.id"
          :to="{ name: 'Salons' }"
          class="group block rounded-2xl border border-gold/30 bg-gradient-to-br from-background to-backgroundDark p-5 shadow-sm transition-transform duration-200 hover:-translate-y-1 hover:shadow-glow-gold"
        >
          <div class="flex items-start justify-between gap-3">
            <div>
              <p class="text-xs uppercase tracking-[0.2em] text-gold/90">{{ room.scope }}</p>
              <h3 class="mt-2 text-xl font-bold text-gold">{{ room.name }}</h3>
            </div>
            <span class="rounded-full border border-gold/40 bg-gold/10 px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.15em] text-gold">
              {{ room.online }} en ligne
            </span>
          </div>

          <p class="mt-4 text-sm text-backgroundLight/90">{{ room.topic }}</p>

          <div class="mt-5 flex items-center justify-between border-t border-gold/20 pt-4 text-sm">
            <span class="text-secondary">{{ room.messages }} messages</span>
            <span class="font-semibold text-gold group-hover:text-white transition-colors">Rejoindre →</span>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script setup>
const rooms = [
  {
    id: 'franche-comte',
    scope: 'Région',
    name: 'Franche-Comté',
    online: 42,
    messages: 186,
    topic: 'Échanges locaux, projets, réseaux et performances régionales.'
  },
  {
    id: 'doubs',
    scope: 'Département',
    name: 'Doubs',
    online: 21,
    messages: 94,
    topic: 'Questions, opportunités et classement départemental.'
  },
  {
    id: 'besancon',
    scope: 'Ville',
    name: 'Besançon',
    online: 13,
    messages: 67,
    topic: 'Discussion locale plus intime, dans votre ville.'
  },
  {
    id: 'national',
    scope: 'National',
    name: 'National',
    online: 76,
    messages: 320,
    topic: 'Le salon général pour comparer les performances et les dynamiques.'
  }
]
</script>
